"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_base_1 = __importDefault(require("./api_base"));
exports.default = {
    get: function (organizationId, fields) {
        if (fields === void 0) { fields = ['id', 'external_name']; }
        return api_base_1.default.get("organizations/" + organizationId, { params: { fields: fields } }).then(function (response) { return response.data.data; });
    }
};
//# sourceMappingURL=organizations_api.js.map